import { useEffect, useState } from 'react';
import { fetchBackendStatus, type BackendStatus } from './lib/api';

const POLL_MS = 30_000;

export function useBackendStatus(): BackendStatus {
  const [status, setStatus] = useState<BackendStatus>({ state: 'checking' });

  useEffect(() => {
    const controller = new AbortController();
    const check = () =>
      fetchBackendStatus(controller.signal).then(setStatus).catch(() => {
        /* aborted on unmount */
      });
    check();
    const timer = window.setInterval(check, POLL_MS);
    return () => {
      controller.abort();
      window.clearInterval(timer);
    };
  }, []);

  return status;
}
